import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import client from "@/lib/api";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";

export default function Article() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  const [nf, setNf] = useState(false);
  useEffect(() => {
    client.get(`/articles/${slug}`).then(({ data }) => setA(data)).catch(() => setNf(true));
  }, [slug]);

  if (nf) return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <p className="font-display text-3xl text-white">Article not found</p>
      <Link to="/newsroom" className="btn-ghost rounded-full px-6 py-3 font-mono2 text-xs uppercase tracking-widest">Back to Newsroom</Link>
    </div>
  );
  if (!a) return <div className="min-h-screen" />;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    headline: a.title,
    description: a.excerpt,
    image: a.cover_image,
    author: { "@type": "Organization", name: a.author || "ImJove Tech" },
    publisher: { "@type": "Organization", name: "ImJove Tech" },
  };

  return (
    <article>
      <SEO title={a.seo_title || `${a.title} — ImJove Tech`} description={a.seo_description || a.excerpt} image={a.cover_image} jsonLd={jsonLd} />
      <div className="mx-auto max-w-[820px] px-6 pt-36 md:px-12">
        <Reveal>
          <Link to="/newsroom" className="mb-8 inline-flex items-center gap-2 font-mono2 text-[11px] uppercase tracking-widest text-white/40 hover:text-white">
            <ArrowLeft size={13} /> Newsroom
          </Link>
          <span className="font-mono2 text-[11px] uppercase tracking-widest text-gold-light">{a.category}</span>
          <h1 className="mt-4 font-display text-4xl font-bold leading-tight tracking-tight text-white sm:text-5xl">{a.title}</h1>
          <p className="mt-4 font-mono2 text-xs uppercase tracking-widest text-white/40">By {a.author}</p>
        </Reveal>
      </div>
      {a.cover_image && (
        <div className="mx-auto mt-10 max-w-[1000px] px-6 md:px-12">
          <img src={a.cover_image} alt={a.title} className="aspect-[16/8] w-full rounded-2xl border border-white/10 object-cover" />
        </div>
      )}
      <div className="mx-auto max-w-[820px] px-6 py-16 md:px-12">
        {/(<[a-z][\s\S]*>)/i.test(a.body || "") ? (
          <div className="article-content" dangerouslySetInnerHTML={{ __html: a.body }} />
        ) : (
          (a.body || "").split("\n\n").map((para, i) => (
            <p key={i} className="mb-6 font-body text-lg leading-relaxed text-white/70">{para}</p>
          ))
        )}
      </div>
    </article>
  );
}
